/**
 * [화주사 정보 관리] 담당자명 형식
 * @description 한글, 영문, 숫자, 특수문자 가능 (\'"|~ 제외) & 공백 입력 불가 & 1자 이상
 */
const validateVenderManagerName = (name: string) => {
  const regex = /^[a-zA-Zㄱ-ㅣ가-힣0-9!@#$%^&*()_+\-=[\]{};:,<>/?]+$/;

  return regex.test(name);
};

export default validateVenderManagerName;
